import { SeoHead } from "../../components/SeoHead";
import { PageSeoKey } from "../../seo/config";
import { capitalizedWord } from "./helper";

type GetMetaProps = {
  type?: string;
  bedroom?: string;
  kind?: string;
  location?: string;
  total?: number;
  description?: string;
  title?: string;
  canonicalValue?: string;
};

const labelForKind = (kind?: string) => {
  if (kind === "land") return "Land";
  if (kind === "apartment") return "Apartments and Flats";
  if (kind === "commercial") return "Commercial Property";
  if (kind === "house") return "Houses";
  return kind ? capitalizedWord(kind) : "Property";
};

export const GetMeta = ({
  type,
  bedroom,
  kind,
  location,
  description,
  title,
  canonicalValue,
}: GetMetaProps) => {
  const locationName = location ? capitalizedWord(location) : "Nigeria";

  if (type) {
    const intent = type === "long lease" ? "rent" : type;
    const intentLabel = intent === "sale" ? "for Sale" : intent === "rent" ? "for Rent" : "for Shortlet";
    const propertyLabel = bedroom ? `${bedroom} ${intent === "shortlet" ? "Shortlet" : "Property"}` : labelForKind(kind);
    const pathSegments = [`property-for-${intent}`];

    if (kind) pathSegments.push(kind);
    if (location) pathSegments.push("in", location);
    if (bedroom && !kind && !location) pathSegments.push("bedroom", bedroom);

    const path = `/${pathSegments.join("/")}`;
    const pageTitle = `${propertyLabel} ${intentLabel} in ${locationName}`;
    const pageDescription =
      intent === "shortlet"
        ? `Book verified ${kind ? `${labelForKind(kind).toLowerCase()} ` : ""}shortlet apartments in ${locationName} on Krent. Find furnished stays, serviced apartments, and flexible booking options.`
        : `Find ${propertyLabel.toLowerCase()} ${intentLabel.toLowerCase()} in ${locationName} on Krent. Browse verified listings by price, location, property type, and bedrooms.`;

    return (
      <SeoHead
        title={pageTitle}
        description={pageDescription}
        path={path}
        keywords={[
          `${propertyLabel.toLowerCase()} ${intentLabel.toLowerCase()} in ${locationName}`,
          `${intent === "shortlet" ? "shortlet apartments" : "property"} in ${locationName}`,
          "Krent Nigeria",
        ]}
      />
    );
  }

  const normalizedCanonical = canonicalValue?.replace(/^\//, "").trim();
  const pageByPath: Record<string, PageSeoKey> = {
    "": "home",
    about: "about",
    contact: "contact",
    faq: "faq",
    privacy: "privacy",
    terms: "terms",
  };
  const page = normalizedCanonical === undefined ? undefined : pageByPath[normalizedCanonical];
  const path = normalizedCanonical === undefined ? undefined : `/${normalizedCanonical}`;

  return <SeoHead page={page} title={title} description={description} path={path} />;
};

export default GetMeta;
